
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate/501c4",
      function () {
        return require("private-next-pages/donate/501c4.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donate/501c4"])
      });
    }
  